export const v4MapsPerPage = 10;

/**
 * According to usage data the max number of maps a v4 user has is 2070. This limit ensures you get all user's v4 maps
 * in one request.
 */
export const v4MapsPerRequest = 3000;
